'use client'

import React from 'react';
import {t} from 'i18next';
import {Tooltip} from '@mui/material';

interface StatusOption {
    value: string;
    label: string;
    colorClass: string;
}

interface Props {
    statusOptions: StatusOption[];
}

const OfferStatusLegend = ({statusOptions}: Props) => {
    return (
        <>
            <div className="d-flex justify-content-md-end flex-wrap mb-3 px-3">
                {statusOptions?.map((offerItem) => {
                    return (
                        <Tooltip
                            key={offerItem.value}
                            title={t(`brand.campaign.manage.${offerItem.value}_explanation`)}
                            arrow
                            placement="top"
                        >

                            <div className="cursor-pointer" key={offerItem.value}>
                                    <span
                                        key={offerItem.value}
                                        className={`calendar-button-dot mx-1 ${offerItem.colorClass}`}
                                    >
                                        {offerItem.label}
                                    </span>
                            </div>
                        </Tooltip>
                    );
                })}
            </div>

        </>
    );
};

export default OfferStatusLegend;